import { z } from 'zod';
import { NullableJsonValue } from "../inputTypeSchemas/NullableJsonValue"

/////////////////////////////////////////
// FEE ITEMS SCHEMA
/////////////////////////////////////////

export const fee_itemsSchema = z.object({
  id: z.bigint(),
  amount: z.number().int().nullable(),
  fee_type: z.string().nullable(),
  permits_type_id: z.bigint().nullable(),
  permits_fee_id: z.bigint().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  standard_conditional_field_key: z.number().int().nullable(),
  conditional_field_id: z.number().int().nullable(),
  data: NullableJsonValue.optional(),
  order: z.number().int().nullable(),
})

export type fee_items = z.infer<typeof fee_itemsSchema>

export default fee_itemsSchema;
